export function WelcomeEmailTab() {
  return <div></div>;
}
